// extracted by mini-css-extract-plugin
export var addButton = "_mj-0";
export var border = "_mj-8";
export var check = "_mj-h";
export var danger = "_mj-6";
export var dropdownContainer = "_mj-1";
export var editModalBody = "_mj-j";
export var footerContainer = "_mj-i";
export var fullWidth = "_mj-a";
export var hide = "_mj-9";
export var icon = "_mj-3";
export var input = "_mj-7";
export var inputFlex = "_mj-b";
export var inputWrapper = "_mj-c";
export var manualFocus = "_mj-5";
export var optionButton = "_mj-4";
export var pillWrapper = "_mj-e";
export var pointer = "_mj-2";
export var showOverflow = "_mj-f";
export var tagsFlex = "_mj-d";
export var xButton = "_mj-g";